<template>
    <div class="pathway-info" v-if="activeTrajectory">
      <ul>
        <li>
          <i class="maintenance"></i>
          Aanleg/onderhoudsjaar: {{ activeTrajectory.construction_year ? activeTrajectory.construction_year : 'Onbekend' }}
        </li>
        <li>
        </li>
        <li>
          <i class="layers"></i>
          Type grondlaag: {{ activeTrajectory.subgrade }}
        </li>
        <li>
          <i class="road"></i>
          Type asfalt: {{ activeTrajectory.surface }}
        </li>
        <li>
          <i class="car"></i>
          Aantal auto's: {{ averageCars | nFormatter }}
        </li>
        <li>
          <i class="truck"></i>
          Aantal vrachtwagens: {{ averageTrucks | nFormatter }}
        </li>
        <li>
          <i class="sun"></i>
          Aantal zonuren i.c.m. warmte dagen: {{ averageHot | nFormatter }}
        </li>
        <li>
          <i class="ice"></i>
          Aantal vorsturen i.c.m. neerslag: {{ averageCold | nFormatter }}
        </li>
      </ul>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import DriveDirections from '../../driveDirection'

export default {
  data () {
    return {
      averageHot: 0,
      averageCold: 0,
      averageCars: 0,
      averageTrucks: 0,
      activeTrajectory: null,
      year: new Date().getFullYear()
    }
  },
  watch: {
    trajectory: function () {
      this.activeTrajectory = this.trajectory
      this.calcAverage()
    },
    driveDirection: function (driveDirection) {
      this.activeTrajectory = driveDirection === DriveDirections.Left ? this.trajectories[0] : this.trajectories[1]
      this.calcAverage()
    }
  },
  mounted () {
    this.activeTrajectory = this.trajectory
    this.calcAverage()
    console.log(this.activeTrajectory)
  },
  methods: {
    calcAverage () {
      if (!this.activeTrajectory.construction_year || this.activeTrajectory.construction_year.length < 4) {
        this.activeTrajectory.construction_year = null
      }
      this.averageHot = Math.round(this.activeTrajectory['hot_and_sun_hours']) || 0
      this.averageCold = Math.round(this.activeTrajectory['freeze_and_rain_hours']) || 0
      this.averageCars = Math.round(this.activeTrajectory['cars']) || 0
      this.averageTrucks = Math.round(this.activeTrajectory['trucks']) || 0
      // this.averageHot = Math.round(this.activeTrajectory['hot_and_sun_hours_' + this.filters.year]) || 0
      // this.averageCold = Math.round(this.activeTrajectory['freeze_and_rain_hours_' + this.filters.year]) || 0
      // this.averageCars = Math.round(this.activeTrajectory['cars_' + this.filters.year]) || 0
      // this.averageTrucks = Math.round(this.activeTrajectory['trucks_' + this.filters.year]) || 0
    }
  },
  computed: {
    ...mapState(['driveDirection', 'trajectory', 'trajectories']),
    ...mapState('projects', ['filters'])
  }
}
</script>
<style lang="sass" scoped>
@import '../../sass/variables'

.pathway-info,
  padding-top: 1em

  ul
    display: flex
    flex-wrap: wrap
  li
    display: flex
    flex: 1 0 50%
    align-items: center
    padding: 1em 1em 1em 0
    i
      margin-right: 2em
</style>



// WEBPACK FOOTER //
// src/components/trajectory/PathwayInfo.vue